// Lib
import React from 'react';
import { useSelector } from 'react-redux';

// Components
import BoardTemplatePickerCategory from './BoardTemplatePickerBodyCategory';
import BoardTemplatePickerCategoriesList from './BoardTemplatePickerBodyCategoriesList';
import BoardTemplatePickerDefault from './BoardTemplatePickerBodyDefault';

// Selectors
import { defaultTemplateListingSelector, templateCollectionsSelector } from '../boardTemplatePickerSelectors';

// Constants
import { NavigationDetail, NavigationLevel } from '../templateTypes';

type Props = {
    navigation: NavigationDetail;
    shouldAutoSelectTemplate?: boolean;
};

const BoardTemplatePickerBody = ({ navigation, shouldAutoSelectTemplate = false }: Props) => {
    const className = 'picker-body';
    const defaultTemplateListing = useSelector(defaultTemplateListingSelector);
    const templateCollections = useSelector(templateCollectionsSelector);

    if (navigation.level === NavigationLevel.SUBCATEGORIES) {
        return (
            <BoardTemplatePickerCategory
                className={className}
                templateCollections={templateCollections}
                selectedCollectionId={navigation.categoryId}
                shouldAutoSelectTemplate={shouldAutoSelectTemplate}
            />
        );
    }

    if (navigation.level === NavigationLevel.CATEGORIES) {
        return <BoardTemplatePickerCategoriesList className={className} templateCollections={templateCollections} />;
    }

    return (
        <BoardTemplatePickerDefault
            className={className}
            defaultTemplateListing={defaultTemplateListing}
            shouldAutoSelectTemplate={shouldAutoSelectTemplate}
        />
    );
};

export default BoardTemplatePickerBody;
